import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import { formatHourMinute } from 'utils/format'

import styles from './grid-header-time.css'

const GridHeaderTime = ({ style, time, color, isOver, onRemove }) => (
  <div style={{ ...style, color }} styleName="cell">
    <div styleName={isOver ? 'content-hover' : 'content-normal'}>
      {formatHourMinute(time.hour, time.minute)}
    </div>
    <div styleName="remove" onClick={onRemove} >x</div>
  </div>
)

GridHeaderTime.propTypes = {
  color: PropTypes.string,
  isOver: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  style: PropTypes.object.isRequired,
  time: PropTypes.object.isRequired,
}

export default CSSModules(GridHeaderTime, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-header-time/grid-header-time.js
 **/